import { OptionsObject, SnackbarOrigin } from "notistack";
import { FreyaScannersNames, PrintMethods, Variant } from "./enums";
import { DownloadFileTypes, PAPER_SIZE } from "@reedexpo/mercury-badge";
import { PaymentOptions } from "./types";
import DensoWaveScannerRed from "../assets/DensoWaveScannerRed.svg";
import TeraScannerRed from "../assets/TeraScannerRed.svg";
import SunmiScannerRed from "../assets/SunmiScannerRed.svg";
import WaspScannerRed from "../assets/WaspScannerRed.svg";
import OtherScanner from "../assets/OtherScanner.svg";
import DensoWaveLarge from "../assets/scanMode/DensoWave.svg";
import TeraLarge from "../assets/scanMode/Terra.svg";
import SunmiLarge from "../assets/scanMode/Sunmi.svg";
import WaspLarge from "../assets/scanMode/Wasp.svg";
import HandMobileScan from "../assets/scanMode/HandMobileScan.svg";
import DensoWaveGreen from "../assets/scanMode/DensoWaveGreen.svg";
import TeraLargeGreen from "../assets/scanMode/TerraGreen.svg";
import SunmiLargeGreen from "../assets/scanMode/SunmiGreen.svg";
import WaspLargeGreen from "../assets/scanMode/WaspGreen.svg";

export const utcTimeOffset = "+0000";
export const spaceCharacter = " ";
export const timeSeparator = "T";

export const JWT_ROLES = {
  RX_ADMIN: "urn:rxrole:rxadmin"
};

export const REG_FIELD_MAX_LENGTHS = {
  FIRST_NAME: 40,
  LAST_NAME: 40,
  JOB_TITLE: 40,
  EMAIL: 80,
  COMPANY_NAME: 100,
  LOCATION: 60,
  BUILDING: 75,
  ADDRESS: 75,
  CITY: 40,
  POSTCODE: 10,
  PHONE: 15,
  REPORTS_TO: 255,
  STANDS_WORKING_ON: 255,
  DEPARTMENT: 40
};

export const FREYA_PHOTO_TIMEOUT = 1500;

export const MAX_CHARACTER_LENGTH_BADGE_DETAILS_FIELD = 25;

export const BADGE_DATE_TIME_FORMAT = "DD-MM-YYYY_HH-mm";

export const SELECT_DATE_TIME_FORMAT = "DD/MM/YY";

export const SELECT_US_DATE_TIME_FORMAT = "MM/DD/YY";

export const UTC_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZZ";

export const DEFAULT_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss[Z]";

export const BADGE_FILTERING_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export const SHOW_DATE_FORMAT = "YYYY-MM-DD";

export const DATE_ZERO = "0001-01-01";

export const TIME_24_HOUR_DATE_FORMAT = "HH:mm";

export const ALLOWED_IMAGE_TYPES = ["jpg", "jpeg", "png"];

export const PDF_IMAGES = {
  logo: "logo",
  image1: "image1",
  image2: "image2",
  image3: "image3"
};

export const JAPAN_BU = "OBU_018";

export const QR_VISITOR_TYPES = {
  tradeVisitor: "T",
  hostedBuyer: "H",
  vipOrBuyersProg: "V",
  speaker: "S",
  pressOrMedia: "M",
  conferenceDelegate: "D",
  exhibitingDelegate: "E",
  studentOrLecturer: "U",
  public: "P",
  coordinator: "C",
  staff: "F",
  contractor: "O"
};

export const ODIN_LOGGING_SOURCE = "Odin";
export const FREYA_LOGGING_SOURCE = "Freya";

export const LOCAL_STORAGE_BADGE_PRINT = "printFormat";

export const V1 = "/v1";
export const V1_REPORTS = V1 + "/reports/";
export const SHOW_SUMMARY = "/showsummary";
export const SHOW_OVERVIEW = "/showoverview";
export const ZONE_ACCESS_BY_HOUR = "/zoneaccessbyhour";
export const ZONE_ACCESS_BY_LOCATION = "/zoneaccessbylocation";
export const EVENT_OVERVIEW_BY_PRODUCT = "/showoverviewbyproduct";
export const ZONE_ACCESSED_BY_HOUR = "/zoneaccessedbyhour";
export const HEALTH = "/health";
export const REG_AND_ATTENDANCE = "/showoverviewbyday";
export const SHOW_DETAILS = "/showdetails";

export const COUNTRY_CODES = {
  USA: "USA",
  IND: "IND",
  AUS: "AUS"
};

export const SNACKBAR_POSITIONS: { [k: string]: SnackbarOrigin } = {
  TOP_RIGHT: { horizontal: "right", vertical: "top" },
  BOTTOM_LEFT: { horizontal: "left", vertical: "bottom" }
};

export const SNACKBAR_VARIANTS: { [key in Variant]: OptionsObject } = {
  [Variant.SUCCESS]: {
    variant: Variant.SUCCESS as const,
    anchorOrigin: SNACKBAR_POSITIONS.BOTTOM_LEFT
  },
  [Variant.WARNING]: {
    variant: Variant.WARNING as const,
    anchorOrigin: SNACKBAR_POSITIONS.BOTTOM_LEFT
  },
  [Variant.ERROR]: {
    variant: Variant.ERROR as const,
    anchorOrigin: SNACKBAR_POSITIONS.BOTTOM_LEFT
  },
  [Variant.INFO]: {
    variant: Variant.INFO as const,
    anchorOrigin: SNACKBAR_POSITIONS.BOTTOM_LEFT
  }
};

export const MAX_API_CALL_RETRY_COUNT = 5;
export const SPACE_CHECK_REGEX = /^(?!^\s)((.)(?!\ {2,})(?!\s$))+$/;
export const NETWORK_FAILURE_ERROR = "NETWORK_FAILURE";

export const __TEST__ = "test";
export const PRINT_METHODS = [
  { key: PrintMethods.PRINT_DIRECT, value: "Printer Direct - Default" },
  { key: PrintMethods.PRINT_SERVER, value: "Print Server" }
];

export const PRINT_FORMATS = [
  { key: PAPER_SIZE.LETTER, value: "US Letter" },
  { key: PAPER_SIZE.FOUR_X_TEN_INCH, value: "4x10 Inches" },
  { key: PAPER_SIZE.A4, value: "A4" },
  { key: PAPER_SIZE.W105xH140mm, value: "4x5 Inches" },
  { key: PAPER_SIZE.W298_X_100, value: "298mm x 100mm" }
];

export const PRINT_FILE_FORMATS = [
  { key: "PDF", value: DownloadFileTypes.PDF },
  { key: "ZPL", value: DownloadFileTypes.ZPL }
];

export const EXCLUDE_COUNTRIES = ["RKS", "ANT"];

export const FREYA_BADGE_FETCH_TIMEOUT = 60000;
export const FREYA_REROUTE_TO_LANDING_TIMEOUT = 3600000;

export const FREYA_BADGE_QR_CODE_PARTS_COUNT = 6;

export const FREYA_REROUTE_LANDING_PAGE_TIMEOUT = 5000;
export const FREYA_SERVICE_DESK_REROUTE_LANDING_PAGE_TIMEOUT = 10000;

export const FREYA_SCAN_POSSIBLE_AFTER_X_MINUTES = 5;
export const FREYA_SCANNED_BADGES_CHECK_TIMEOUT = 120000;

export const FREYA_NPS_SURVEY_TIMEOUT = 4000;
export const FREYA_NPS_SURVEY_CONFIRMATION_TIMEOUT = 2000;
export const FREYA_NPS_SURVEY_TRIGGER_INTERVAL = 8;

export const ODIN_EVENT_EDITION_STORAGE_KEY = "event";
export const CAMERA_DEVICE_STORAGE_KEY = "camera-device-storage-key";
export const COLOCATED_SHOWS_STORAGE_KEY = "colocatedShow";
export const CMS_EVENT_DETAILS_STORAGE_KEY = "cmsEventDetailsByGbsCode";
export const EVENT_SWITCH_DELAY = 1000;
export const ODIN_PRODUCTS_FETCH_INTERVAL = 600000;
export const ODIN_LOGO_SWITCH_KEY = "badge-logo";
export const ODIN_START_PAGE_SWITCH_KEY = "start-page";
export const FREYA_ORIENTATION_KEY = "freya-orientation";
export const STAFF_OVERRIDE_CAMERA_KEY = "override-camera";

export const USER_ACCESS_VALUES = ["None", "CustomerServicesManager", "CustomerServicesAgent", "Finance"];
export const LOCAL_STORAGE_LAST_ACTIVITY_KEY = "auth.lastActiveTime";
export const IDLE_INTERVAL_CHECK_SECONDS = 25;
export const IDLE_WARNING_OFFSET_MINUTES = 5;
export const UI_LANG_KEY = "cl";

export const FREYA_SCANNING_MODE_STORAGE_KEY = "sm";

export const NUMBER_OF_SESSIONS_IN_ONE_CALL = 100;

export const RECEIPT_DATE_FORMAT = "DD/MM/YYYY HH:mm";

export const initPaymentOptions: PaymentOptions = {
  paymentAmount: { title: "", value: "" },
  paymentMethod: { title: "", value: "" },
  authorisationNumber: { title: "", value: "" }
};

export enum BADGE_PRINTED_AT {
  PRINTED_AT_SHOW = "Printed At Show (PAS)",
  PRINTED_AT_SHOW_PLUS = "Printed At Show Plus (PAS+)",
  PRINTED_AT_HOME = "Printed At Home (PAH)"
}

export const MAX_MULTILINGUAL_ITEMS = 900;

export const HOURS_SINCE_LAST_PUSH_THRESHOLD = 24;

export const FREYA_SCANNERS = [
  { id: FreyaScannersNames.DENSOWAVE, image: DensoWaveScannerRed },
  { id: FreyaScannersNames.TERAPRO, image: TeraScannerRed },
  { id: FreyaScannersNames.SUNMI, image: SunmiScannerRed },
  { id: FreyaScannersNames.WASP, image: WaspScannerRed },
  { id: FreyaScannersNames.OTHER, image: OtherScanner }
];

export const FREYA_SCANNERS_LARGE = [
  { id: FreyaScannersNames.DENSOWAVE, image: DensoWaveLarge },
  { id: FreyaScannersNames.TERAPRO, image: TeraLarge },
  { id: FreyaScannersNames.SUNMI, image: SunmiLarge },
  { id: FreyaScannersNames.WASP, image: WaspLarge },
  { id: FreyaScannersNames.OTHER, image: HandMobileScan }
];

export const FREYA_SCANNERS_LARGE_SUCCESS = [
  { id: FreyaScannersNames.DENSOWAVE, image: DensoWaveGreen },
  { id: FreyaScannersNames.TERAPRO, image: TeraLargeGreen },
  { id: FreyaScannersNames.SUNMI, image: SunmiLargeGreen },
  { id: FreyaScannersNames.WASP, image: WaspLargeGreen },
  { id: FreyaScannersNames.OTHER, image: HandMobileScan }
];

export const FREYA_SCANNER_STORAGE_KEY = "SELECTED_SCANNER_ID";
